<template>
  <div class='event-attendee-actions' v-on:click="toggleVisible()">
      <i class="far fa-ellipsis-v"></i>
      <div class='action-list' v-if="visible">
        <div class="action" v-if="!blockedConnection" v-on:click="blockAttendee()">
          <i class="far fa-minus-circle"></i>
          {{ lang.get('event_strings.global-chat.blocked_attendee_title') }}
        </div>
        <div class="action" v-if="blockedConnection" v-on:click="unBlockAttendee()">
          <i class="fas fa-minus-circle"></i>
          {{ lang.get('event_strings.global-chat.unblocked_attendee_title') }}
        </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {

  props : ['blockedConnection', 'attendee'],

  data: function () {
    return {
      visible: false,
      fetchingBlockingConnection: false    
    }
  },

  methods: {
    toggleVisible () {
      return this.visible = !this.visible
    },

    blockAttendee () {
      if (this.fetchingBlockingConnection) return;
      this.fetchingBlockingConnection = true
      var data = {blocked_event_attendee_id: this.attendee.event_attendee_id}
      axios.post('/api/v1/blocked_connections', data)
        .then(this.handleBlockAttendeeSuccess)
        .catch(function errorBlockAttendee (err) {
          this.$toasted.error('error blocking attendee', {duration: 4000})
        }.bind(this))
        .then(function always () {
          this.fetchingBlockingConnection = false
        }.bind(this))
    },

    handleBlockAttendeeSuccess (res) {
      this.$root.$emit('blocked-connection', res.data)
      if (window.globalChatController) window.globalChatController.addRoomBlockedConnectionIfExists(res.data)
    },

    unBlockAttendee () {
      if (this.fetchingBlockingConnection) return;
      var attendee = Object.assign({}, this.attendee)
      this.fetchingBlockingConnection = true
      var data = {blocked_event_attendee_id: attendee.event_attendee_id, _method: 'DELETE'}
      axios.delete(`/api/v1/blocked_connections/${this.blockedConnection.id}`, data)
        .then(function success (res) {
          this.$root.$emit('unblocked-connection', attendee)
          if (window.globalChatController) window.globalChatController.removeRoomBlockedConnectionIfExists(res.data)
        }.bind(this))
        .catch(function error (err) {
          this.$toasted.error('error unblocking attendee', {duration: 4000})
        }.bind(this))
        .then(function always() {
          this.fetchingBlockingConnection = false
        }.bind(this))
    }

  },

}
</script>
